import {loadable} from 'router/routes';
import {initialState as searchRequestInitialState} from 'search-request/search-request-reducer';
import SearchUtils from 'search/search-utils';
import {Page, fetchCity, isMonthlyPage} from './utils';
import CMSUtils from 'utils/cms';

const City = loadable(() => import('mid-funnel/city/City'));

City.getInitialState = async ({state, cookies, params: {slug}, route}) => {
    const cleanedSlug = slug.replace(/-parking$/, '');
    const city = await fetchCity(state, cleanedSlug);
    const pageType = Page.MID_FUNNEL;
    const isMonthly = isMonthlyPage(route);
    const {
        data: {timezone},
    } = city;

    const searchRequest = {
        ...searchRequestInitialState,
        pageType,
        ...SearchUtils.createTimeWindowParams(pageType, {}, timezone),
    };

    if (isMonthly) {
        searchRequest.monthly = isMonthly;
    }

    return {
        ...state,
        city,
        searchRequest,
        page: await CMSUtils.getPageData({
            cookies,
            slug: cleanedSlug,
            city,
            customType: 'consumer-page-city',
        }),
    };
};

export default City;
